<template>
    <tbody class="text-dark-gray block lg:table-row-group">
        <slot></slot>
    </tbody>
</template>
